/**
 * Update Status
 */
$(document).on("ready", function () {
  $(".updateStatus").on("change", function () {
    var $which = $(this);
    var section = $which.attr("data-section");
    var status = $which.attr("data-status");
    var inwp = $which.attr("data-inwp");

    if (section === "fafsa" || section === "standardized-test") {
      inwp = '';
      if($which.is(':checked')) status='Complete';
      else status='';
    }
    //alert('section: '+section+' ,value: '+status + ' ,inwp: '+inwp);
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: {
        action: 'fw_update_status',
        section: section,
        status: status,
        inwp: inwp,
      },
      dataType: "html",
      success: function (data) {},
      error: function (data) {},
    });
  });
   $(".statusUpdate").on("click", function (e) {
          //e.preventDefault();
          console.log("update status clicked");
          //var p = $(this).parent("p");
          ///*
          $.ajax({
            type: "POST",
            url: "/wp-admin/admin-ajax.php",
            data: {
              action: 'fw_status_update',
              section: $(this).data("section"),
            },
            dataType: "html",
            success: function (data) {
            },
            error: function (xhr, desc, err) {
              console.log(xhr);
              console.log("Details0: " + desc + "\nError:" + err);
            },
          });
          //*/
          /*
          $.ajax({
                type: "POST",
                url: '/wp-admin/admin-ajax.php',
                data: {action:'fw_update_status','section':'ms-games-says-who','status':'InProgress','inwp':'true'}, // serializes the form's elements.
                success: function(data)
                {
                },
                error: function(){
                }
            });
            */
        });
});
